var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"mt-8"},[_c('h1',[_vm._v("Administration")]),_c('p',{staticClass:"mt-4"},[_vm._v("Select an area from the Administrator navigation to get started.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }